<template>
  <div class="start-rework-dialog-part-replace-record">
    <div class="table-section">
      <div class="item-title">{{ $t('asm_start_rework_dialog_part_replace_record.fgljghjl') }}</div>
      <div class="table-content">
        <custom-table
          :data="replaceList"
          tableCode="rework_part_replace_record"
          :slots="['oldPartCodeAndName','partCodeAndName','action']"
          height="250px"
        >
          <template v-slot:oldPartCodeAndName="scope">
            {{scope.row.oldPartCode || '-'}}/{{scope.row.oldPartName || '-'}}
          </template>
          <template v-slot:partCodeAndName="scope">
            {{scope.row.partCode || '-'}}/{{scope.row.partName || '-'}}
          </template>
          <template v-slot:action="scope">
            <el-button
              type="text"
              size="mini"
              @click="onShowPartImg(scope.row)"
            >{{ $t('asm_start_rework_dialog_part_replace_record.cha_kan_tu_pian') }}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="onDelPartReplaceRecord(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
    </div>
    <div class="table-section">
      <div class="item-title">{{ $t('asm_start_rework_dialog_part_replace_record.ghqtljjl') }}</div>
      <div class="btn-group">
        <div
          class="btn-add"
          @click="addOtherPart"
        >
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>
              {{ $t('asm_start_rework_dialog_part_replace_record.ghqtlj') }}
            </span>
          </div>
        </div>
      </div>
      <div class="table-content">
        <custom-table
          :data="otherReplaceList"
          tableCode="rework_part_replace_record"
          :slots="['oldPartCodeAndName','partCodeAndName','action']"
          height="250px"
        >
          <template v-slot:oldPartCodeAndName="scope">
            {{scope.row.oldPartCode || '-'}}/{{scope.row.oldPartName || '-'}}
          </template>
          <template v-slot:partCodeAndName="scope">
            {{scope.row.partCode || '-'}}/{{scope.row.partName || '-'}}
          </template>
          <template v-slot:action="scope">
            <el-button
              type="text"
              size="mini"
              @click="onShowPartImg(scope.row)"
            >{{ $t('asm_start_rework_dialog_part_replace_record.cha_kan_tu_pian') }}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="onDelOtherRecord(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [],
  components: {
  },
  props: {
    workOrderId: String,
    reworkList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      // 返工零件更换记录
      replaceList: [],
      // 更换其他零件记录
      otherReplaceList: [],
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    async delPartRecord(orderPartId) {
      const reqUrl = `${apis.workOrderPartDelete}/${orderPartId}`;
      return this.$postJSON(reqUrl);
    },
    // 更换其他零件记录的删除
    async onDelOtherRecord(row) {
      await this.delPartRecord(row.orderPartId);
      this.$message({
        message: this.$t('Common.com_delete_success'),
        type: 'success',
      });
      // 更新 更换其他零件记录
      this.getOtherReplaceRecord();
    },
    onDelPartReplaceRecord(row) {
      this.$emit('delReplaceRecord', row);
    },
    onShowPartImg(row) {
      this.$emit('showImg', row);
    },
    // 获取返工零件更换记录
    getReworkPartReplaceRecord() {
      const reqData = {
        workOrderId: this.workOrderId,
        isReworkPart: true,
      };
      const reqUrl = apis.workOrderPartList;

      return this.$getJSON(reqUrl, reqData).then((res) => {
        this.replaceList = res.data;
      });
    },
    // 获取：更换其他零件记录
    getOtherReplaceRecord() {
      const reqData = {
        workOrderId: this.workOrderId,
        isReworkPart: false,
      };
      const reqUrl = apis.workOrderPartList;

      return this.$getJSON(reqUrl, reqData).then((res) => {
        this.otherReplaceList = res.data;
      });
    },
    async init() {
      this.getReworkPartReplaceRecord();
      this.getOtherReplaceRecord();
    },
    addOtherPart() {
      this.$emit('addOtherPart', this.otherReplaceList);
    },
  },
  created() {
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss">
.start-rework-dialog-part-replace-record {
  .table-section {
    margin-top: 24px;
  }
  .table-content {
    // max-height: 100px;
  }

  .btn-group {
    margin-bottom: 20px;
    overflow: hidden;

    .btn-add {
      cursor: pointer;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: rgba(245, 245, 245, 1);
      border: 1px dashed rgba(228, 228, 228, 1);
      color: #333333;
      font-size: 12px;
      position: relative;
      float: left;
      width: 100%;

      .icon {
        color: #00afff;
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
}
</style>
